import { IGatewayCompany, ReceiverParsedKeyType } from '@apps-common/types/portal/cloud-receiver'

export interface IReceiverKpiCardColors {
  bg: string
  kpiBg: string
  text: string
  border: string
  borderActive: string
}

export const receiverParams: { key: ReceiverParsedKeyType; colors: IReceiverKpiCardColors; condition: (c: IGatewayCompany) => boolean }[] =
  [
    {
      key: 'gateways',
      colors: {
        bg: 'bg-brand',
        kpiBg: 'bg-on-brand/10',
        text: 'text-on-brand',
        border: 'border-surface',
        borderActive: 'ring-[3px] ring-brand'
      },
      condition: (c: IGatewayCompany) => true
    },
    {
      key: 'all',
      colors: {
        bg: 'bg-info',
        kpiBg: 'bg-on-info/10',
        text: 'text-on-info',
        border: 'border-surface',
        borderActive: 'ring-[3px] ring-info'
      },
      condition: (c: IGatewayCompany) => true
    },
    {
      key: 'buffer',
      colors: {
        bg: 'bg-warning',
        kpiBg: 'bg-on-warning/10',
        text: 'text-on-warning',
        border: 'border-transparent',
        borderActive: 'ring-[3px] ring-warning'
      },
      condition: (c: IGatewayCompany) => c.company.queueSize > 0
    },
    {
      key: 'offline',
      colors: {
        bg: 'bg-error',
        kpiBg: 'bg-on-error/10',
        text: 'text-on-error',
        border: 'border-surface',
        borderActive: 'ring-[3px] ring-error'
      },
      condition: (c: IGatewayCompany) => c.company.paths.every((p) => !p.online)
    },
    {
      key: 'online',
      colors: {
        bg: 'bg-success',
        kpiBg: 'bg-on-success/10',
        text: 'text-on-success',
        border: 'border-surface',
        borderActive: 'ring-[3px] ring-success'
      },
      condition: (c: IGatewayCompany) => c.company.paths.every((p) => p.online)
    },
    {
      key: 'degraded',
      colors: {
        bg: 'bg-text/20',
        kpiBg: 'bg-text/10',
        text: 'text-text',
        border: 'border-surface',
        borderActive: 'ring-[3px] ring-text/20'
      },
      condition: (c: IGatewayCompany) => {
        const online = c.company.paths.some((p) => p.online)
        const offline = c.company.paths.some((p) => !p.online)

        return online && offline
      }
    }
  ]
